import { LogService } from 'src/app/services/logging.service';
import { UnprocessableEntityError } from './../acumatica/acumatica-errors';
import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialog } from '../common/alert-dialog/alert-dialog.component';
import { AudioService, Sound } from './audio.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService extends ErrorHandler {
  constructor(
    private ngZone: NgZone,
    private dialog: MatDialog,
    private logging: LogService,
    private audio: AudioService
  ) {
    super();
  }

  public handleError(error: any, showErrorDialog: boolean = true, additionalData: object | undefined = undefined): string {
    let message: string;
    if (error instanceof UnprocessableEntityError) {
      // pull out field-level errors
      message = "Acumatica Entity Field Error" + (error.fieldErrors.length == 1 ? '' : 's') + "<hr />" +
        "<ul><li>"
        + error.fieldErrors.join("</li><li>")
        + "</ul>";
    } else {
      message = error?.message || error?.toString() || '(undefined error)';
    }

    this.ngZone.run(() => {
      let username = JSON.parse(localStorage.getItem('user') || '{Username: \'(unknown)\'}').Username;
      try {
        this.logging.error(username, [message], JSON.stringify(error, Object.getOwnPropertyNames(error)));
        if (additionalData !== undefined) this.logging.error(username, 'Error Data', JSON.stringify(additionalData));
      }
      catch (loggingEx) {
        console.error(loggingEx);
        if (additionalData !== undefined) console.error(additionalData);
      }

      this.audio.play(Sound.ErrorBeep);
      if (showErrorDialog) this.dialog.open(AlertDialog, {
        data: { icon: 'Error', message: message, buttonText: 'Ok' }
      });
    });

    return message;
  }
}